import styled from 'styled-components';
import tw from 'tailwind.macro';

export const Wrapper = styled.div`
  ${tw`bg-green py-64 md:py-144`};
  ${props =>
    (props.marginBottom === '0' && tw`mb-0`) ||
    (props.marginBottom === '6' && tw`mb-6`) ||
    (props.marginBottom === '8' && tw`mb-8`) ||
    (props.marginBottom === '12' && tw`mb-12`) ||
    (props.marginBottom === '14' && tw`mb-14`) ||
    (props.marginBottom === '16' && tw`mb-16`) ||
    (props.marginBottom === '24' && tw`mb-24`) ||
    (props.marginBottom === '32' && tw`mb-32`) ||
    (props.marginBottom === '48' && tw`mb-48`) ||
    (props.marginBottom === '64' && tw`mb-64`) ||
    (props.marginBottom === '144' && tw`mb-144`)}
  ${props =>
    (props.textAlign === 'left' && tw`text-left`) ||
    (props.textAlign === 'center' && tw`text-center`) ||
    (props.textAlign === 'right' && tw`text-right`)}
  ${props => 
    (props.color === 'white' && tw`bg-white`)
  }
`;
